export class SseError extends Error {
  constructor(message: string) {
    super(message.startsWith('SSE: ') ? message : `SSE: ${message}`);
    this.name = 'SseError';
  }
}

export class SseAbortedError extends Error {
  constructor() {
    super('SSE: aborted');
    this.name = 'SseAbortedError';
  }
}

export const isSseAbortedError = (error: unknown): boolean => error instanceof SseAbortedError;
